import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import SMCLabel from '../../../components/Simple/SMCLabel';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import RowLayout from '../../../components/Layouts/RowLayout';
import {SMCCheckbox} from "../../../components/Simple/SMCCheckbox";
import Indentation from "../../../components/Simple/Indentation";
import { SystemSettingsGetSchema } from '../../../api/DBSchema/SystemSettings';
import EditorLayout from '../../../components/Layouts/EditorLayout';
import { ObjectTypes } from '../../../api/consts';

//both pages of portal settings schema and system settings schema are equal --> so we can get each of them
const pageSchema = SystemSettingsGetSchema.pages.userPasswordSecurity;
const pageId = pageSchema.pageId;

function BaseSettingsPasswordSecurity({
    settingsObject,
    setSettingsData,
    objectType
}) {
    const { t } = useTranslation();

    const pageData = settingsObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setSettingsData([pageId, paramName], value);
    }, [setSettingsData]);

    
    const userPasswordEnforceLength         = pageData[pageSchema.userPasswordEnforceLength];
    const userPasswordEnforceRenewal        = pageData[pageSchema.userPasswordEnforceRenewal];
    const userPasswordEnforceRenewalPeriod  = pageData[pageSchema.userPasswordEnforceRenewalPeriod];
    const userPasswordLengthMin             = pageData[pageSchema.userPasswordLengthMin];
    const userPasswordLengthMax             = pageData[pageSchema.userPasswordLengthMax];
    const userPasswordReuseChars            = pageData[pageSchema.userPasswordReuseChars];
    const userPasswordReuseCharsLength      = pageData[pageSchema.userPasswordReuseCharsLength];
    const userPasswordDontReuseByNumber     = pageData[pageSchema.userPasswordDontReuseByNumber];
    const userPasswordDontReuseByNumberVal  = pageData[pageSchema.userPasswordDontReuseByNumberVal];
    const userPasswordDontReuseByTime       = pageData[pageSchema.userPasswordDontReuseByTime];
    const userPasswordDontReuseByTimeVal    = pageData[pageSchema.userPasswordDontReuseByTimeVal];
    const userPasswordNoWhitespaces         = pageData[pageSchema.userPasswordNoWhitespaces];
    const userPasswordNotUID                = pageData[pageSchema.userPasswordNotUID];
    const userPasswordRepeatingChars        = pageData[pageSchema.userPasswordRepeatingChars];
    const userPasswordRepeatingCharsVal     = pageData[pageSchema.userPasswordRepeatingCharsVal];
    const userPasswordComplexity            = pageData[pageSchema.userPasswordComplexity];
    const userPasswordComplexityNumRules    = pageData[pageSchema.userPasswordComplexityNumRules];
    const userPasswordComplexityUppercase   = pageData[pageSchema.userPasswordComplexityUppercase];
    const userPasswordComplexityLowercase   = pageData[pageSchema.userPasswordComplexityLowercase];
    const userPasswordComplexityNumbers     = pageData[pageSchema.userPasswordComplexityNumbers];
    const userPasswordComplexitySpecialChars    = pageData[pageSchema.userPasswordComplexitySpecialChars];


    return (
        <EditorLayout>
            <RowLayout spacing="4px">
                <SMCCheckbox
                    label={t('SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_LENGTH')}
                    checked={userPasswordEnforceLength}
                    onChange={e => setPageValue(pageSchema.userPasswordEnforceLength, e.target.checked)}
                />
                <SMCTextInput
                    value={userPasswordLengthMin}
                    onChange={e => setPageValue(pageSchema.userPasswordLengthMin, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t('SMC_GEN_AND')}</SMCLabel>
                <SMCTextInput
                    value={userPasswordLengthMax}
                    onChange={e => setPageValue(pageSchema.userPasswordLengthMax, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_CHARACTERS_TEXT")}</SMCLabel>
            </RowLayout>
            <RowLayout spacing="4px">
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_CHAR_REUSE_TEXT_1")}
                    checked={userPasswordReuseChars}
                    onChange={e => setPageValue(pageSchema.userPasswordReuseChars, e.target.checked)}
                />
                <SMCTextInput
                    value={userPasswordReuseCharsLength}
                    onChange={e => setPageValue(pageSchema.userPasswordReuseCharsLength, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_CHAR_REUSE_TEXT_2")}</SMCLabel>
            </RowLayout>
            <RowLayout spacing="4px">
                <SMCCheckbox
                    label={objectType===ObjectTypes.SYSTEM_SETTINGS ? t("SMP.SYSTEM.SERVICE_DOMAINS.SYSTEM_SECURITY.ENFORCE_PASSWORD_RENEWAL") : t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_RENEWAL")}
                    checked={userPasswordEnforceRenewal}
                    onChange={e => setPageValue(pageSchema.userPasswordEnforceRenewal, e.target.checked)}
                />
                <SMCTextInput
                    value={userPasswordEnforceRenewalPeriod}
                    onChange={e => setPageValue(pageSchema.userPasswordEnforceRenewalPeriod, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_DONT_REUSE_BY_TIME_TEXT_2")}</SMCLabel>
            </RowLayout>
            <RowLayout spacing="4px">
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_DONT_REUSE_BY_NUMBER_TEXT_1")}
                    checked={userPasswordDontReuseByNumber}
                    onChange={e => setPageValue(pageSchema.userPasswordDontReuseByNumber, e.target.checked)}
                />
                <SMCTextInput
                    value={userPasswordDontReuseByNumberVal}
                    onChange={e => setPageValue(pageSchema.userPasswordDontReuseByNumberVal, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_DONT_REUSE_BY_NUMBER_TEXT_2")}</SMCLabel>
            </RowLayout>
            <RowLayout spacing="4px">
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_DONT_REUSE_BY_TIME_TEXT_1")}
                    checked={userPasswordDontReuseByTime}
                    onChange={e => setPageValue(pageSchema.userPasswordDontReuseByTime, e.target.checked)}
                />
                <SMCTextInput
                    value={userPasswordDontReuseByTimeVal}
                    onChange={e => setPageValue(pageSchema.userPasswordDontReuseByTimeVal, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_DONT_REUSE_BY_TIME_TEXT_2")}</SMCLabel>
            </RowLayout>
            <SMCCheckbox
                label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_NO_WHITESPACES")}
                checked={userPasswordNoWhitespaces}
                onChange={e => setPageValue(pageSchema.userPasswordNoWhitespaces, e.target.checked)}
            />
            <SMCCheckbox
                label={objectType===ObjectTypes.SYSTEM_SETTINGS ? t("SMP.SYSTEM.SERVICE_DOMAINS.SYSTEM_SECURITY.ENFORCE_PASSWORD_NOT_UID") : t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_NOT_UID")}
                checked={userPasswordNotUID}
                onChange={e => setPageValue(pageSchema.userPasswordNotUID, e.target.checked)}
            />
            <RowLayout spacing="4px">
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_REPEATING_CHARS_TEXT_1")}
                    checked={userPasswordRepeatingChars}
                    onChange={e => setPageValue(pageSchema.userPasswordRepeatingChars, e.target.checked)}
                />
                <SMCTextInput
                    value={userPasswordRepeatingCharsVal}
                    onChange={e => setPageValue(pageSchema.userPasswordRepeatingCharsVal, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_REPEATING_CHARS_TEXT_2")}</SMCLabel>
            </RowLayout>
            <RowLayout spacing="4px">
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_COMPLEXITY_TEXT_1")}
                    checked={userPasswordComplexity}
                    onChange={e => setPageValue(pageSchema.userPasswordComplexity, e.target.checked)}
                />
                <SMCTextInput
                    value={userPasswordComplexityNumRules}
                    onChange={e => setPageValue(pageSchema.userPasswordComplexityNumRules, e.target.value)}
                    width={35}
                />
                <SMCLabel>{t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_COMPLEXITY_TEXT_2")}</SMCLabel>
            </RowLayout>
            <Indentation>
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_COMPLEXITY_UPPERCASE")}
                    checked={userPasswordComplexityUppercase}
                    onChange={e => setPageValue(pageSchema.userPasswordComplexityUppercase, e.target.checked)}
                    disabled={!userPasswordComplexity}
                />
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_COMPLEXITY_LOWERCASE")}
                    checked={userPasswordComplexityLowercase}
                    onChange={e => setPageValue(pageSchema.userPasswordComplexityLowercase, e.target.checked)}
                    disabled={!userPasswordComplexity}
                />
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_COMPLEXITY_NUMBERS")}
                    checked={userPasswordComplexityNumbers}
                    onChange={e => setPageValue(pageSchema.userPasswordComplexityNumbers, e.target.checked)}
                    disabled={!userPasswordComplexity}
                />
                <SMCCheckbox
                    label={t("SMP.SYSTEM.SERVICE_DOMAINS.USER_SECURITY.ENFORCE_PASSWORD_COMPLEXITY_SPECIAL_CHARS")}
                    checked={userPasswordComplexitySpecialChars}
                    onChange={e => setPageValue(pageSchema.userPasswordComplexitySpecialChars, e.target.checked)}
                    disabled={!userPasswordComplexity}
                />
            </Indentation>
        </EditorLayout>

    )
}

export default BaseSettingsPasswordSecurity;